import {mapState} from "pinia";
import useApplicationStore from "../stores/application_module";

export default {
    data (){
        return {
            hide_additional_data: false,
            pricing_error: '',
            authorisation_pricing_program_hrl: null,
            authorisation_pricing_program:{},
            AUTHORISATION_PRICING_CODE:'authenticatePricingProgram',
            transaction_fee_collection_type: null,
            has_interchange: false,
            show_charge: {
                SHOW_SEC_RATE: false,
                SHOW_SEC_BASE: false,
                SHOW_NON_SEC_RATE: false,
                SHOW_NON_SEC_BASE: false,
            },
            service_item_charges: [], //array of all the charges
            additional_data_belong_to_list : {
                ADDITIONAL_DATA_BELONGS_TO_EQUIPMENT_OFFERING : '1',
                ADDITIONAL_DATA_BELONGS_TO_PROCESSING_OFFERING : '2',
                ADDITIONAL_DATA_BELONGS_TO_ONLINE_OFFERING : '3',
            }
        }
    },
    mounted() {
        let vm = this
        //moved from mixin to avoid multiple calls by  child components loading mixin
        if (!!this.quote.acquiring_offer && !!this.quote.acquiring_offer.transaction_pricing_external_id) {
            this.getAcquiringOffer(this.quote.acquiring_offer.transaction_pricing_external_id)
        }
    },
    computed: {
        ...mapState(useApplicationStore, {
            acquiring_offerings:'acquiring_offerings',
            parameters:'parameters',
            matched_packages:'matched_packages'}),
        hasPricingOfferings: function (){
            return this.acquiring_offerings.length > 0 && !!this.quote.acquiring_offer && !!this.quote.acquiring_offer.transaction_pricing_external_id
        },
        isSimplifiedPricing: function (){
            return !!this.quote.acquiring_offer && this.quote.acquiring_offer.fee_collection_type === "SIMPLIFIED"
        },
        pricingCurrencyCode: function () {
            let pricing_currency = this.quote.acquiring_offer.currency;
            if (pricing_currency !== '' && typeof pricing_currency !== 'undefined') {
                return pricing_currency;
            }
            return '';
        },
        currencySymbol: function () {
            let symbol = '', vm = this, pricing_currency = this.quote.acquiring_offer.currency;
            if (pricing_currency !== '' && typeof pricing_currency !== 'undefined') {
                let currency = this.parameters.hasOwnProperty('CURRENCIES_PARAM') ? this.parameters.CURRENCIES_PARAM.find(obj =>
                    obj.id === pricing_currency) : {}
                symbol = !!currency ? currency.currency_symbol : pricing_currency;
            }
            return symbol;
        },
        hasInterchange: function(){
            return this.charges.some(charge => charge.fee_collection_type === 'INTERCHANGE');
        },
        charges: function () {
            let chargeItem = [], vm = this;
            if (!!this.quote && !!this.quote.acquiring_offer && !!this.quote.acquiring_offer.charge_items) {
                this.quote.acquiring_offer.charge_items.forEach(charge_item => {
                    let item = charge_item;
                    charge_item['formatted_charges'] = {};
                    charge_item.charge_item_prices.forEach((tier, index) => {
                        if (index === 0) {
                            let interchange_charge = '';

                            tier.charge_item_price_charges.forEach((tier_charge) => {
                                if (tier_charge.category == 1) {
                                    switch(tier_charge.fee_type){
                                        case '1': //perc
                                            charge_item['formatted_charges']['secure_charge_rate'] = vm.getPricingFee(tier_charge, charge_item);
                                            break;
                                        case '2': //base
                                            charge_item['formatted_charges']['secure_charge_base'] = vm.getPricingFee(tier_charge, charge_item);
                                            break;
                                    }
                                }
                                if (tier_charge.category == 2) {
                                    switch(tier_charge.fee_type) {
                                        case '1': //perc
                                            charge_item['formatted_charges']['non_secure_charge_rate'] = vm.getPricingFee(tier_charge, charge_item);
                                            break;
                                        case '2': //base
                                            charge_item['formatted_charges']['non_secure_charge_base'] = vm.getPricingFee(tier_charge, charge_item);
                                            break;
                                    }
                                }
                                if (tier_charge.category == 4) {
                                    if (interchange_charge === '') {
                                        interchange_charge = vm.getPricingFee(tier_charge, charge_item);
                                    } else {
                                        interchange_charge = interchange_charge + ' + ' + vm.getPricingFee(tier_charge, charge_item);
                                    }
                                    //string them together $20.00 + 7%
                                    charge_item['formatted_charges']['interchange_charge'] = interchange_charge;
                                }
                            });
                        }
                    });
                    chargeItem.push(item);
                    chargeItem.sort(function(a, b) {
                        if (a.hasOwnProperty('charge_item_name') && !!a.charge_item_name &&
                            b.hasOwnProperty('charge_item_name') && !!b.charge_item_name) {
                            var nameA = a.charge_item_name.toUpperCase(); // ignore upper and lowercase
                            var nameB = b.charge_item_name.toUpperCase(); // ignore upper and lowercase
                            if (nameA < nameB) {
                                return -1;
                            }
                            if (nameA > nameB) {
                                return 1;
                            }
                        }

                        // names must be equal
                        return 0;
                    });
                });
            }
            return chargeItem;
        },
        hrlValue: function (){
            //add the hrl_value set in boarding or select the first one in merchant
            if (this.authorisation_pricing_program_hrl && this.authorisation_pricing_program_hrl.hrl_value) {
                return this.formatNumberByLocale(this.authorisation_pricing_program_hrl.hrl_value) + "%";
            }
            return this.authorisation_pricing_program && this.authorisation_pricing_program.parameters && this.authorisation_pricing_program.parameters[0]
                            && this.authorisation_pricing_program.parameters[0].hrl_value  ?
                this.formatNumberByLocale(this.authorisation_pricing_program.parameters[0].hrl_value) + "%"
                : false
        }
    },
    methods: {
        setSelectedCardBorder: function ($event, id){
            let card_parent = $('#' + id).closest('.card');
            card_parent.toggleClass('card--selected-pricing', $event === '1')
        },
        getPricingFee: function (pricing_fee, parent_item = null) {
            let vm = this, charge = '';
            //use default pricing if default pricing is not set return NULL
            let base_value = pricing_fee.base_charge ? pricing_fee.base_charge
                : (!!pricing_fee.default_base_charge ? pricing_fee.default_base_charge : 'N/A');
            let perc_value = !!pricing_fee.perc_charge ? pricing_fee.perc_charge : (!!pricing_fee.default_perc_charge ? pricing_fee.default_perc_charge : 'N/A');
            pricing_fee['charge_decimals'] = parent_item && parent_item.hasOwnProperty('charge_decimals')
                ? parent_item['charge_decimals'] : '2'; //assign charge decimal from service item, otherwise = 2

            //if any of the pricing is N/A. Prevent the user from saving the pricing.

            switch (pricing_fee.fee_type) {
                case '1': //Perc
                    charge = perc_value !== 'N/A' ? vm.formatNumberByLocale(perc_value, pricing_fee.charge_decimals) + '%' : perc_value;
                    break;

                case '2': //Base
                    charge = base_value !== 'N/A' ? vm.formatNumberByLocale(base_value, pricing_fee.charge_decimals, 'currency', vm.pricingCurrencyCode) : base_value;
                    break;

                case '3':
                    charge = perc_value !== 'N/A' && base_value !== 'N/A' ?
                        vm.formatNumberByLocale(base_value, pricing_fee.charge_decimals, 'currency', vm.pricingCurrencyCode) + ' + ' + vm.formatNumberByLocale(perc_value) + '%' : 'N/A';
                    break;

                default:
                    charge = vm.formatNumberByLocale(pricing_fee.default_charge, pricing_fee.charge_decimals, 'currency', vm.pricingCurrencyCode)
                    break;
            }

            if (charge === 'N/A' &&  parent_item.is_boarding_activated == '1') {
                let item_name = '';
                if (!!parent_item) {
                    if (parent_item.hasOwnProperty('service_item_name')) {
                        item_name = parent_item.service_item_name;
                    } else if (parent_item.hasOwnProperty('charge_item_name')) {
                        item_name = parent_item.charge_item_name;
                    }
                }
                this.service_item_charges.push(charge);
                this.pricing_error = this.lang('pricing_charge_is_null_error').replace('{0}', item_name)
            }

            if (this.service_item_charges.includes('N/A') && this.pricing_error !== '') {
                this.quote.pricing_has_error = true; //prevent submission
            } else {
                this.quote.pricing_has_error = false;
            }

            return charge;
        },
        formatFee: function (fee_value, decimal = 2) {
            return this.formatNumberByLocale(fee_value, decimal, 'currency', this.pricingCurrencyCode)
        },
        formatServiceFrequency : function (data){
            return this.formatSelectType(this.parameters, data, 'SERVICE_FREQUENCY');
        },
        getCardType(charge_item_name) {
            charge_item_name = charge_item_name.toLowerCase();
            let card_type = '', clazz= '';
            let cards = ['visa', 'jcb', 'mcrd', 'amex', 'msto', 'dns', 'elec', 'mastercard', 'maestro', 'master card'];
            for (let el of cards) {
                if (charge_item_name.includes(el)) {
                    card_type = el;
                    break;
                }
            }
            switch (card_type) {
                case 'visa':
                case 'mcrd':
                case 'amex':
                case 'msto':
                case 'dns':
                case 'elec':
                    clazz = 'filter cardTypeIcon card-'  + card_type ;
                    break;
                case 'visauk':
                    clazz = 'filter cardTypeIcon card-visa';
                    break;
                case 'mastercard': case 'master card':
                    clazz = 'filter cardTypeIcon card-mcrd';
                    break;
                case 'maestro':
                    clazz = 'filter cardTypeIcon card-msto';
                    break;
                // case 'jcb':
                //     clazz = 'filter cardTypeIcon card-jcb';
                //     break;
                default:
                    clazz = 'las la-credit-card la-2x';
                    break;
            }

            return clazz;
        },
        sortCharges: function (charges) {
            if (charges.length > 0) {
                function compare(a, b) {
                    if (a.is_mandatory == '1' && b.is_mandatory == '0') {
                        return -1;
                    }
                    if (a.is_mandatory == '0' && b.is_mandatory == '1') {
                        return 1;
                    }
                    // a must be equal to b
                    return 0;
                }
                return  this.jsonCopy(charges).sort(compare);
            }
            return [];
        },
        isValidPackagePeriod: function (package_data, throw_error = false) {
            if (package_data.is_offer_code_time_limited === '0') {
                return true;
            }

            let today = new Date();
            let offer_code_from = new Date(package_data['offer_code_from']);
            let offer_code_to = new Date(package_data['offer_code_to']);
            if (today < offer_code_from || today > offer_code_to) {
                if (throw_error) {
                    //'Offer Package %0% is expired or currently unavailable. Please select a new Offer Package.
                    this.notifyError(this.lang('validation_error'), this.lang('validation_offer_package_is_expired').replace('{0}', package_data.package_name))
                }
                return false;
            }
            return true;
        },
        validateOfferPackagePeriod: function (){
            let package_external_id = !!this.quote.package_external_id ? this.quote.package_external_id : '';
            let selected_package = this.matched_packages.hasOwnProperty(package_external_id) ? this.matched_packages[package_external_id] : null;

            if(!!selected_package){
                if (!this.isValidPackagePeriod(selected_package.criteria, true)){
                    return false;
                }
            }else{
                this.notifyError(this.lang('validation_error'), this.lang('your_offer_package_is_invalid'))
                return false;
            }

            return true;
        },
        getAcquiringOffer: function (val = '') {
            let vm = this;
            vm.loading = true; //!this.loading;
            if (vm.objectIsNotEmpty(this.acquiring_offerings)) {
                let id = val === vm.acquiring_offerings[0].transaction_pricing_external_id ? val : vm.acquiring_offerings[0].transaction_pricing_external_id;
                const url = `/application/ajaxgetacquiringoffer/` + id;
                vm.getAxiosInstance().get(url).then(response => {
                    if (response['data']['result'] === 'SUCCESS') {
                        vm.setAcquiringOffer(response['data']['transaction_pricing']);
                    }
                    vm.loading = false;
                });
            } else {
                vm.notifyError(vm.lang('error'), vm.lang('no_transaction_pricing_offer_available'));
                vm.loading = false;
            }
        },
        setAcquiringOffer: function (transaction_pricing){
            let transaction_charges = [], service_charges = [], vm = this;
            if (!!transaction_pricing.charge_item_groups){
                transaction_pricing.charge_item_groups.forEach(item_group => {
                    item_group.charge_items.forEach(charge_item => {
                        charge_item.is_boarding_activated = charge_item.is_mandatory;
                        transaction_charges.push(charge_item);
                    })
                })
            }

            transaction_pricing.service_items.forEach(service_item => {
                service_item.is_boarding_activated = service_item.is_mandatory;
                // if (service_item.hasOwnProperty('service_item_charges') && service_item.service_item_charges.length > 0)
                    service_charges.push(service_item);
            })

            //TODO what happens when a pricing offer changes after a quote has saved it's pricing offer but not converted
            // TODO Do we merge the two?
            if (!!this.quote.acquiring_offer.charge_items && this.quote.acquiring_offer.charge_items.length > 0) {
                transaction_charges.forEach(charge_item => {
                    let quote_has_charge = vm.quote.acquiring_offer.charge_items.find(obj => {
                        return obj.charge_item_external_id === charge_item.charge_item_external_id
                    })
                    if (!!quote_has_charge) {
                        charge_item.is_boarding_activated = quote_has_charge.is_mandatory !== '0' ? quote_has_charge.is_mandatory : quote_has_charge.is_boarding_activated;
                        vm.assignSavedBoardingChargeItems(charge_item, quote_has_charge);
                    }
                });
            }

            if (!!this.quote.acquiring_offer.service_items && this.quote.acquiring_offer.service_items.length > 0) {
                service_charges.forEach(service_item => {
                    let quote_has_charge = vm.quote.acquiring_offer.service_items.find(obj => {
                      return  obj.service_charge_item_external_id === service_item.service_charge_item_external_id
                    })

                    if (!!quote_has_charge) {
                        service_item.is_boarding_activated = quote_has_charge.is_mandatory !== '0' ? quote_has_charge.is_mandatory : quote_has_charge.is_boarding_activated;
                        vm.assignSavedBoardingServiceItems(service_item, quote_has_charge);
                    }
                });
            }
            //keep a copy of the selected offer for setting the additional data
            let selected_offer = this.jsonCopy(this.quote.acquiring_offer);
            this.quote['acquiring_offer'] = transaction_pricing;

            this.quote.acquiring_offer.charge_items = this.sortCharges(transaction_charges);
            this.quote.acquiring_offer.service_items = this.sortCharges(service_charges);
            this.quote.acquiring_offer.additional_data = this.getAdditionalAttributes(transaction_pricing, this.parameters, selected_offer);
            this.hide_additional_data = this.quote.acquiring_offer.additional_data.every(item => {  return item.parameters.length === 1});
            this.setAuthorisationPricingProgram(this.quote.acquiring_offer)
            this.getHrlValueFromRetrievedData(this.parameters, this.quote.acquiring_offer)
            //check if there is a fee control to hide some acquiring charges.
            //Be noted we call it both here and when entering into this page from other tabs. When we refresh the page, the
            //equpmentoffer/onlineoffer may be null as they were set later after entering page. So we added call here.
            this.feeControlProcess();

            this.transaction_fee_collection_type = transaction_pricing.fee_collection_type;

            this.setShowChargeAndHasInterchange();
        },
        assignSavedBoardingChargeItems: function (charge_item, saved_charge_item) {
            charge_item.charge_item_prices.forEach((tier_charges, tier) => {
                tier_charges.charge_item_price_charges.forEach((price, pi) => {
                    let has_base_charge = saved_charge_item.charge_item_prices
                        && !!saved_charge_item.charge_item_prices[tier]
                        && saved_charge_item.charge_item_prices[tier].charge_item_price_charges
                        && saved_charge_item.charge_item_prices[tier].charge_item_price_charges[pi]
                        && saved_charge_item.charge_item_prices[tier].charge_item_price_charges[pi].base_charge;
                    let has_perc_charge = saved_charge_item.charge_item_prices
                        && !!saved_charge_item.charge_item_prices[tier]
                        && saved_charge_item.charge_item_prices[tier].charge_item_price_charges
                        && saved_charge_item.charge_item_prices[tier].charge_item_price_charges[pi]
                        && saved_charge_item.charge_item_prices[tier].charge_item_price_charges[pi].perc_charge;
                    if (has_base_charge) {
                        price.base_charge = saved_charge_item.charge_item_prices[tier].charge_item_price_charges[pi].base_charge;
                    }
                    if (has_perc_charge) {
                        price.perc_charge = saved_charge_item.charge_item_prices[tier].charge_item_price_charges[pi].perc_charge;
                    }
                });
            });
        },
        assignSavedBoardingServiceItems: function (service_item, saved_service_item) {
            service_item.service_item_charges.forEach((price, pi) => {
                let has_base_charge = saved_service_item.service_item_charges
                    && !!saved_service_item.service_item_charges[pi]
                    && saved_service_item.service_item_charges[pi].base_charge;
                let has_perc_charge = saved_service_item.service_item_charges
                    && !!saved_service_item.service_item_charges[pi]
                    && saved_service_item.service_item_charges[pi].perc_charge;
                if (has_base_charge) {
                    price.base_charge = saved_service_item.service_item_charges[pi].base_charge;
                }
                if (has_perc_charge) {
                    price.perc_charge = saved_service_item.service_item_charges[pi].perc_charge;
                }
            });
        },
        getAdditionalAttributes: function (boarding_acquiring_offer, parameters, saved_boarding_acquiring_offer = null) {
            let fee_collection_type = boarding_acquiring_offer.fee_collection_type;
            let alliance_external_id = boarding_acquiring_offer.alliance_external_id;
            let additional_parameters = []

            if (parameters.hasOwnProperty('ADDITIONAL_DATA_PARAM')) {
                additional_parameters = parameters['ADDITIONAL_DATA_PARAM'].filter(obj => {
                    return obj.belongs_to === this.additional_data_belong_to_list.ADDITIONAL_DATA_BELONGS_TO_PROCESSING_OFFERING
                })
            }

            let attributes = [];
            let vm = this;
            let additional_attributes = {};

            // Group Records in transaction pricing additional_data
            boarding_acquiring_offer.additional_data.forEach(obj => {
                if (!additional_attributes.hasOwnProperty(obj.additional_attribute_external_id)) {
                    additional_attributes[obj.additional_attribute_external_id] = {'id': obj.additional_attribute_external_id};
                }
                if (!additional_attributes[obj.additional_attribute_external_id].hasOwnProperty('records')) {
                    additional_attributes[obj.additional_attribute_external_id]['records'] = {};
                }
                additional_attributes[obj.additional_attribute_external_id]['records'][obj.additional_record_external_id] = obj;
            });

            // Saved Records
            let saved_records =  {};
            if (!!boarding_acquiring_offer && Array.isArray(boarding_acquiring_offer['additional_data'])) { //data from config portal
                boarding_acquiring_offer['additional_data'].forEach(record => {
                    saved_records[record['additional_attribute_external_id']] = record['additional_record_external_id'];
                });
            }
            if (!!saved_boarding_acquiring_offer && Array.isArray(saved_boarding_acquiring_offer['additional_data'])) { //data from saved boarding offer
                saved_boarding_acquiring_offer['additional_data'].forEach(record => {
                    if (record['additional_record_external_id']) {
                        saved_records[record['additional_attribute_external_id']] = record['additional_record_external_id'];
                    }
                });
            }

            additional_parameters.forEach(obj => {
                let attribute = {};
                if (obj.fee_collection === '1' && fee_collection_type === 'INTERCHANGE') {
                    attribute = obj;
                }
                if (obj.fee_collection === '2' && fee_collection_type === 'BLENDED') {
                    attribute = obj;
                }
                if (obj.fee_collection === '3' && fee_collection_type === 'SIMPLIFIED') {
                    attribute = obj;
                }
                attribute['update_key'] = Math.random();
                attribute['additional_record_external_id'] = '';
                if (attribute.hasOwnProperty('category_name') && additional_attributes.hasOwnProperty(attribute.additional_attribute_external_id)) {
                    attribute['parameters'] = [];
                    attribute['parameter_list'] = [];
                    obj.additional_records.forEach(record => {
                        if (additional_attributes[attribute.additional_attribute_external_id]['records'].hasOwnProperty(record['additional_record_external_id'])) {
                            record['id'] = record['additional_record_external_id'];
                            record['text'] = record['record_name'];
                            if (obj.has_parent_entity === '1') {
                                attribute['parameter_list'].push(record);
                            } else {
                                attribute['parameters'].push(record);
                            }
                        }
                    });

                    if (attribute['parameters'].length === 1) {
                        attribute['additional_record_external_id'] = attribute['parameters'][0]['id'];
                    }

                    if (saved_records.hasOwnProperty(attribute['additional_attribute_external_id'])) {
                        attribute.additional_record_external_id = saved_records[attribute['additional_attribute_external_id']];
                    }

                    attributes.push(attribute);
                }
            });
            attributes.forEach(parent => {
                vm.setChildParameter(attributes, parent);
            });
            return attributes;
        },
        setChildParameter: function (additional_data, parent) {
            let vm = this;
            if (parent.has_parent_entity != '1') {
                additional_data.forEach((datum, d_index) => {
                    if (datum.has_parent_entity === '1'
                        && (datum.parent_entity_id === parent['additional_attribute_external_id'])
                        && (!!parent.additional_record_external_id && parent.additional_record_external_id !== '')) {
                        let child_parameters = datum['parameter_list'].filter(obj => {
                            return parent.additional_record_external_id === obj.parent_additional_record_external_id;
                        });
                        if (child_parameters.length === 1) {
                            additional_data[d_index]['additional_record_external_id'] = child_parameters[0]['id'];
                        }
                        additional_data[d_index]['update_key'] = Math.random();
                        additional_data[d_index]['parameters'] = child_parameters;
                        vm.$forceUpdate();
                    }
                })
            }
        },
        feeControlProcess: function () {
            /* fee control is a feature configured in equipment offer or online offer service. If it matches the reference
            * of the acquiring charge code, the acquiring shall be hidden from UI */
            let vm = this;
            let fee_control_codes = [];

            if (vm.objectIsNotEmpty(vm.quote.equipment_offer)) {
                fee_control_codes = vm.getFeeControlCodes(vm.quote.equipment_offer);
            }
            else if (vm.objectIsNotEmpty(vm.quote.online_offer)) {
                fee_control_codes = vm.getFeeControlCodes(vm.quote.online_offer);
            }

            //loop through all the service items (aka acquiring charges) in the pricing page
            if (!!fee_control_codes && Array.isArray(fee_control_codes)) {
                if (vm.objectIsNotEmpty(vm.quote.acquiring_offer)
                    && vm.npPropertyExistAndIsArray(vm.quote.acquiring_offer, 'service_items')) {
                    vm.quote.acquiring_offer.service_items.forEach(service_item => {
                        if (service_item.charge_ref && (fee_control_codes.indexOf(service_item.charge_ref) !== -1)) {
                            service_item['is_hidden_by_fee_control'] = '1';
                        }
                        else {
                            service_item['is_hidden_by_fee_control'] = '0';
                        }
                    });
                }

                if (vm.objectIsNotEmpty(vm.quote.acquiring_offer)
                    && vm.npPropertyExistAndIsArray(vm.quote.acquiring_offer, 'charge_items')) {
                    vm.quote.acquiring_offer.charge_items.forEach(charge_item => {
                        if (charge_item.charge_item_ref && (fee_control_codes.indexOf(charge_item.charge_item_ref) !== -1)) {
                            charge_item['is_hidden_by_fee_control'] = '1';
                        }
                        else {
                            charge_item['is_hidden_by_fee_control'] = '0';
                        }
                    });
                }
            }
        },
        getFeeControlCodes: function (equipment_offer) {
            let vm = this;
            let fee_control_codes = [];
            if (!!equipment_offer && vm.npPropertyExistAndIsArray(equipment_offer, 'bundles')) {
                equipment_offer.bundles.forEach(bundle => {
                    if (vm.bundleIsSelected(bundle) && vm.npPropertyExistAndIsArray(bundle, 'bundle_items')) {
                        bundle.bundle_items.forEach(bundle_item => {
                            if (vm.bundleItemIsSelected(bundle_item) && vm.npPropertyExistAndIsArray(bundle_item, 'equipment_features')) {
                                bundle_item.equipment_features.forEach(feature => {
                                    let is_selected_fee_control_feature = vm.featureIsSelected(feature) && vm.isFeeControlFeature(feature);
                                    if (is_selected_fee_control_feature && !!(feature.feature_api_code)) {
                                        fee_control_codes.push(feature.feature_api_code);
                                    }
                                });
                            }

                            if (vm.bundleItemIsSelected(bundle_item) && vm.npPropertyExistAndIsArray(bundle_item, 'service_features')) {
                                bundle_item.service_features.forEach(feature => {
                                    let is_selected_fee_control_feature = vm.featureIsSelected(feature) && vm.isFeeControlFeature(feature);
                                    if (is_selected_fee_control_feature && !!(feature.feature_api_code)) {
                                        fee_control_codes.push(feature.feature_api_code);
                                    }
                                });
                            }
                        });
                    }
                });
            }
            return fee_control_codes;
        },
        bundleIsSelected: function (bundle_data){
            return bundle_data.hasOwnProperty('is_boarding_activated') && (bundle_data.is_boarding_activated === '1');
        },
        bundleItemIsSelected: function (bundle_item){
            return bundle_item.hasOwnProperty('is_boarding_activated') && (bundle_item.is_boarding_activated === '1');
        },
        featureIsSelected: function (feature_data){
            return feature_data.hasOwnProperty('selected') && (feature_data.selected === '1');
        },
        isFeeControlFeature: function (feature_data){
            return feature_data.hasOwnProperty('feature_category') && (feature_data.feature_category === 'FEE_CONTROL');
        },
        setShowCharge: function (charge_item){
            if (!charge_item.hasOwnProperty('formatted_charges')){
                return;
            }
            if (charge_item.formatted_charges.hasOwnProperty('secure_charge_rate')) {
                this.show_charge.SHOW_SEC_RATE = true;
            }
            if (charge_item.formatted_charges.hasOwnProperty('secure_charge_base')) {
                this.show_charge.SHOW_SEC_BASE = true;
            }
            if (charge_item.formatted_charges.hasOwnProperty('non_secure_charge_rate') ) {
                this.show_charge.SHOW_NON_SEC_RATE = true;
            }
            if (charge_item.formatted_charges.hasOwnProperty('non_secure_charge_base')) {
                this.show_charge.SHOW_NON_SEC_BASE = true;
            }
        },
        setAuthorisationPricingProgram: function(acquiring_offer){
            if(acquiring_offer.hasOwnProperty('additional_data') && acquiring_offer.additional_data.length > 0){
                this.authorisation_pricing_program = acquiring_offer.additional_data.find(
                    (datum) =>
                        !!datum.additional_record_external_id && datum.additional_record_external_id !== '' &&
                        datum.has_parent_entity === '1' &&  datum.category_code === this.AUTHORISATION_PRICING_CODE
                );
            }
        },
        getHrlValueFromRetrievedData: function (parameters, retrieved_boarding_acquiring_offer = null) {
            let fee_collection_type = !!retrieved_boarding_acquiring_offer ? retrieved_boarding_acquiring_offer.fee_collection_type : '';
            let additional_parameters = parameters['ADDITIONAL_DATA_PARAM'].filter(obj => {
                return obj.belongs_to === this.additional_data_belong_to_list.ADDITIONAL_DATA_BELONGS_TO_PROCESSING_OFFERING
            });
            let vm = this;
            if (fee_collection_type === "SIMPLIFIED") {
                retrieved_boarding_acquiring_offer['additional_data'].forEach(record => {
                    let {additional_attribute_external_id, additional_record_external_id} = record;
                    let additional_parameter = additional_parameters.find(f => f.additional_attribute_external_id === additional_attribute_external_id);
                    if (additional_parameter?.category_code) {
                        if (additional_parameter.category_code === this.AUTHORISATION_PRICING_CODE) {
                            let {additional_records = []} = additional_parameter;
                            let additional_record = additional_records.find(f => f.additional_record_external_id === additional_record_external_id);
                            if (additional_record && additional_record.hrl_value) {
                                vm.authorisation_pricing_program_hrl = {...additional_record};
                            }
                        }
                    }
                });
            }
        },
        setShowChargeAndHasInterchange: function () {
            let vm = this;
            vm.has_interchange = false;
            if (!!vm.quote && !!vm.quote.acquiring_offer && !!vm.quote.acquiring_offer.charge_items) {
                let quoteData = vm.quote;
                quoteData.acquiring_offer.charge_items.forEach(charge_item => {
                    charge_item['formatted_charges'] = {};
                    charge_item.charge_item_prices.forEach((tier, index) => {
                        if (index === 0) {
                            let interchange_charge = '';

                            tier.charge_item_price_charges.forEach((tier_charge) => {
                                if (tier_charge.category == 1) {
                                    switch(tier_charge.fee_type){
                                        case '1': //perc
                                            charge_item['formatted_charges']['secure_charge_rate'] = vm.getPricingFee(tier_charge, charge_item);
                                            break;
                                        case '2': //base
                                            charge_item['formatted_charges']['secure_charge_base'] = vm.getPricingFee(tier_charge, charge_item);
                                            break;
                                    }
                                }
                                if (tier_charge.category == 2) {
                                    switch(tier_charge.fee_type) {
                                        case '1': //perc
                                            charge_item['formatted_charges']['non_secure_charge_rate'] = vm.getPricingFee(tier_charge, charge_item);
                                            break;
                                        case '2': //base
                                            charge_item['formatted_charges']['non_secure_charge_base'] = vm.getPricingFee(tier_charge, charge_item);
                                            break;
                                    }
                                }
                                if (tier_charge.category == 4) {
                                    if (interchange_charge === '') {
                                        interchange_charge = vm.getPricingFee(tier_charge, charge_item);
                                    } else {
                                        interchange_charge = interchange_charge + ' + ' + vm.getPricingFee(tier_charge, charge_item);
                                    }
                                    //string them together $20.00 + 7%
                                    charge_item['formatted_charges']['interchange_charge'] = interchange_charge;
                                }
                            });
                        }
                    });
                    vm.setShowCharge(charge_item);
                    if (charge_item.fee_collection_type === 'INTERCHANGE') {
                        vm.has_interchange = true;
                    }
                });
            }
        },
    },
    watch: {
        'hasPricingOfferings': {
            immediate:true,
            handler: function (val){
                if (val){
                    this.getAcquiringOffer(this.quote.acquiring_offer.transaction_pricing_external_id)
                }
            }
        },
        'acquiring_offerings': {
            immediate:true,
            handler: function (val, oldVal) {
                if (this.objectIsNotEmpty(val) && val !== oldVal) {
                    this.getAcquiringOffer(val[0].transaction_pricing_external_id);
                }
            }
        }
    }
}